import { render, staticRenderFns } from "./TrendAnalysisTab.vue?vue&type=template&id=06dd2acc&scoped=true"
import script from "./TrendAnalysisTab.vue?vue&type=script&lang=ts"
export * from "./TrendAnalysisTab.vue?vue&type=script&lang=ts"
import style0 from "./TrendAnalysisTab.vue?vue&type=style&index=0&id=06dd2acc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd2acc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VChip,VDatePicker,VDivider,VIcon,VMenu,VProgressCircular,VSpacer,VTextField})
